import React, { useEffect, useState } from "react";
import CreateQuestPopup from "../CreateQuestPopup/CreateQuestPopup";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CreateQuest = ( {onQuestCreated} ) => {
  const [showPopup, setShowPopup] = useState(false);
  const [context, setContext] = useState("");
  const [profileImage, setProfileImage] = useState("");

  useEffect(() => {
    const fetchProfileImage = async () => {
      const email = localStorage.getItem("userEmail");
      if (!email) return;

      try {
        const res = await fetch(`${BACKEND_URL}/user/${email}/profile-image`);
        const data = await res.json();
        if (res.ok && data?.profileImage) {
          setProfileImage(data.profileImage);
        }
      } catch (error) {
        console.error("❌ Error fetching profile image:", error);
      }
    };

    fetchProfileImage();
  }, []);

  return (
    <>
      <div className="w-full grow">
        <div
          data-dark="On"
          className="w-full bg-white rounded-2xl flex flex-col gap-4 p-4 sm:p-5"

        >
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 w-full">
            {/* Profile image */}
            <div className="w-10 h-10 min-w-10 min-h-10 rounded-full overflow-hidden border border-slate-300 shadow-sm shrink-0">
              {profileImage ? (
                <img
                  src={profileImage}
                  alt="User"
                  className="w-full h-full object-cover"
                />
              ) : (
                <img
                  src="/person.png"
                  alt="Default User"
                  className="w-full h-full object-cover"
                />
              )}
            </div>

            {/* Textarea */}
            <div className="flex-grow w-full bg-zinc-100 rounded-md">
              <textarea
                placeholder="What challenge are you facing right now?"
                className="w-full px-3 py-3 text-slate-700 text-sm font-normal font-['Source_Sans_Pro'] leading-snug placeholder-slate-400 bg-transparent resize-none focus:outline-none"
                rows={1}
                value={context}
                onChange={(e) => setContext(e.target.value)}
              />
            </div>

            {/* Button */}
            <button
              onClick={() => {
                if (context.trim().length === 0) return;
                setShowPopup(true);
              }}
              className="px-5 py-3 bg-gradient-to-br from-cyan-500 to-cyan-700 rounded-md shadow-md hover:scale-[1.03] active:scale-95 hover:shadow-lg transition-all duration-200 ease-in-out group whitespace-nowrap"
            >
              <span className="text-white text-sm font-semibold font-['Rubik'] leading-tight group-hover:tracking-wide transition-all duration-200">
                Create Quest
              </span>
            </button>
          </div>
        </div>
      </div>

      {showPopup && (
        <CreateQuestPopup
          isOpen={true}
          onClose={() => setShowPopup(false)}
          initialContext={context}
          onQuestCreated={onQuestCreated}
        />
      )}
    </>
  );
};

export default CreateQuest;
